import AppSidebar from '../Sidebar';
import { cn } from 'lib/utils';
import { MenuIcon } from 'lucide-react';
import Text from '../Text';
import { fontSizes } from 'appconstants';
import WrapperFunctional from './index.function';

interface WrapperProps {
  children: React.ReactNode;
  className?: string;
}

const Wrapper = ({ children, className }: WrapperProps) => {
  const { open, setOpenMobile, openMobile, isMobileScreen, loading } = WrapperFunctional();

  return (
    <div className='w-full h-screen'>
      {isMobileScreen && (
        <div className='w-full h-14 flex items-center gap-4 px-4 border-b border-border'>
          <MenuIcon className='cursor-pointer' onClick={() => setOpenMobile(!openMobile)} />
          <Text text='Dole Admin' size={fontSizes.h24} className='font-bold' />
        </div>
      )}
      <AppSidebar className='border-r bg-white' />
      <main
        className={cn(
          'max-h-screen overflow-y-auto py-2 md:py-7 !pb-0 px-6',
          'transition-all duration-300 ease-in-out',
          open ? 'md:ms-64' : 'md:ms-16',
          className,
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default Wrapper;
